/**
 * Empty function used as default property for React components
 */
const noop = () => {};

export default noop;
